import React, {Component} from 'react';
import {DateTime} from 'luxon';

import FlipUnit from './FlipUnit';

export default class CountDown extends Component {
    state = {
        days: 0,
        daysShuffle: true,
        hours: 0,
        hoursShuffle: true,
        minutes: 0,
        minutesShuffle: true,
        seconds: 0,
        secondsShuffle: true
    };

    componentDidMount() {
        this.timerID = setInterval(this.updateTime, 50);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    updateTime = () => {
        const eventDate = DateTime.fromISO(this.props.startTime);
        const time = eventDate.diffNow([
            'days', 'hours', 'minutes', 'seconds', 'millisecond'
        ]);

        // set time units
        const days = time.days;
        const hours = time.hours;
        const minutes = time.minutes;
        const seconds = time.seconds;

        // on hour change, update hours and shuffle state
        if (days !== this.state.days) {
            const daysShuffle = !this.state.daysShuffle;
            this.setState({
                days,
                daysShuffle
            });
        }

        // on hour change, update hours and shuffle state
        if (hours !== this.state.hours) {
            const hoursShuffle = !this.state.hoursShuffle;
            this.setState({
                hours,
                hoursShuffle
            });
        }

        // on minute change, update minutes and shuffle state
        if (minutes !== this.state.minutes) {
            const minutesShuffle = !this.state.minutesShuffle;
            this.setState({
                minutes,
                minutesShuffle
            });
        }

        // on second change, update seconds and shuffle state
        if (seconds !== this.state.seconds) {
            const secondsShuffle = !this.state.secondsShuffle;
            this.setState({
                seconds,
                secondsShuffle
            });
        }
    }

    render() {
        const {
            days,
            hours,
            minutes,
            seconds,
            daysShuffle,
            hoursShuffle,
            minutesShuffle,
            secondsShuffle
        } = this.state;

        return (
            <div className="flipClock m-auto flex flex-col md:flex-row">
                <div className="flex flex-row w-full mb-4 md:mb-0">
                    <FlipUnit
                        unit={'days'}
                        digit={days}
                        shuffle={daysShuffle}
                    />
                    <FlipUnit
                        unit={'hours'}
                        digit={hours}
                        shuffle={hoursShuffle}
                    />
                </div>
                <div className="flex flex-row w-full">
                    <FlipUnit
                        unit={'minutes'}
                        digit={minutes}
                        shuffle={minutesShuffle}
                    />
                    <FlipUnit
                        unit={'seconds'}
                        digit={seconds}
                        shuffle={secondsShuffle}
                    />
                </div>
            </div>
        );
    }
}
